import { combineLatest, fromEvent, Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export class LocalStorageUtil {
  private static storageChanges$ = fromEvent(window, 'storage').pipe(startWith(true));
  private static changes$ = new Subject();

  static typeObject = 'object';

  static changes(): Observable<any> {
    return combineLatest([
      LocalStorageUtil.changes$.asObservable(),
      LocalStorageUtil.storageChanges$,
    ]).pipe(map(() => true));
  }

  static setItem(key: string, value: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      LocalStorageUtil.changes$.next(true);
    } catch (e) {
      console.warn('localStorage blocked (sandboxed iframe, strict browser privacy settings)', e);
    }
  }

  static getItem(key: string): any {
    let value: string | null = null;
    try {
      value = localStorage.getItem(key);
    } catch (e) {
      console.warn('localStorage blocked (sandboxed iframe, strict browser privacy settings)', e);
      return null;
    }
    if (value === null) { return null; }
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  static removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
      LocalStorageUtil.changes$.next(true);
    } catch (e) {
      console.warn('localStorage blocked (sandboxed iframe, strict browser privacy settings)', e);
    }
  }
}
